import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/danger/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/danger/')({
  component: Page,
});
